import { useEffect, useState } from "react";

const useFormValidation = () => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    const checkInvalidFeedback = () => {
      const invalidElements = document.querySelectorAll(".invalid-feedback");

      // Verifica se existe algum elemento que NÃO está com `display: none`
      const hasVisibleInvalidFeedback = Array.from(invalidElements).some(
        (el) => window.getComputedStyle(el).display !== "none",
      );

      setIsButtonDisabled(hasVisibleInvalidFeedback);
    };

    checkInvalidFeedback(); // Verificação inicial

    const observer = new MutationObserver(checkInvalidFeedback);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return isButtonDisabled;
};

export default useFormValidation;
